<script setup></script>

<template>
  <div class="preloader">
    <!-- Add your preloader animation or image here -->
    <img src="../assets/images/PRELOADER-HIGH-RES.gif" alt="Loading..." />
  </div>
</template>

<style scoped>
.preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
</style>
